<template>
    <div>
        <button type="submit" class="btn btn-primary btn-sm btn-success">Crear</button>
    </div>
</template>
<script>
    export default {
        name: "btnCrear"
    }
</script>

<style scoped>

</style>